window.UltimasComprasController = ControllerBase.extend({
    name: "UltimasComprasController",
    framework: "knockout",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'CPF/CNPJ', prop: 'CpfCnpj' },
            { title: 'Nome', prop: 'Nome' }
        ],
        getData: function () {

            var cliente = this.cliente
                 ? this.cliente
                 : ControllerBase.instances['CadastroClienteController'].model;

            return this.toJS(cliente);
        },
    }),

    tamanhoPagina: 20,

    ajax: function() {
        return {
            url: "/Cliente/_UltimasCompras",
            type: "post",
            cache: false,
            data: {
                codigoCliente: this.orcamento ? this.orcamento.get("CodigoCliente") : this.cliente.get("Codigo"),
                tamanhoPagina: this.tamanhoPagina

            }
        };
    },

    atualizarPaginador: function(data) {

        this.paginador = new Paginator({
            container: "#page-ultimas-compras",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

    },

    antesBinding: function() {

        this.appendToModel({ name: "DataInicial", value: null });
        this.appendToModel({ name: "DataFinal", value: null });
        this.appendToModel({ name: "Produtos", value: [] });
        this.appendToModel({ name: "CodigoProduto", value: null });
        this.appendToModel({ name: "ReferenciaProduto", value: null });
        this.appendToModel({ name: "DescricaoProduto", value: null });
        this.appendToModel({ name: "ClasseProduto", value: null });
        this.appendToModel({ name: "CodigoFornecedor", value: null });
        this.appendToModel({ name: "NomeFornecedor", value: null });

        this.model.DataInicial.subscribe($.proxy(this.limpar, this));
        this.model.DataFinal.subscribe($.proxy(this.limpar, this));
        this.model.Produtos.subscribe($.proxy(this.limpar, this));
        this.model.CodigoProduto.subscribe($.proxy(this.limpar, this));
        this.model.ReferenciaProduto.subscribe($.proxy(this.limpar, this));
        this.model.DescricaoProduto.subscribe($.proxy(this.limpar, this));
        this.model.ClasseProduto.subscribe($.proxy(this.limpar, this));
        this.model.CodigoFornecedor.subscribe($.proxy(this.limpar, this));

    },

    limpar: function() {
        this.model.Entities.removeAll();

        if (this.paginador) {
            this.paginador.limpar();
        }

    },

    aposBinding: function() {

        this.atualizarPaginador(this.toJS(this.model));
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });

    },

    paginar: function(e) {
        this.pesquisar(null, null, e.page);
    },

    pesquisar: function(mode, e, pagina) {

        pagina = pagina || 1;

        if (!global.isFormValid("#form-ultimas-compras")) {
            return;
        }

        var codigosProdutos = [];

        if (this.model.Produtos() && this.model.Produtos().length > 0) {
            $.each(this.model.Produtos(),
                function() {
                    codigosProdutos.push(this.Codigo);
                });
        }
        var codcliente = this.orcamento ? this.orcamento.get("CodigoCliente") : this.cliente.get("Codigo"); // FNX-907
        var filtros = {
            CodigoCliente: codcliente,
            DataInicial: this.model.DataInicial(),
            DataFinal: this.model.DataFinal(),
            CodigoProduto: this.model.CodigoProduto(),
            ReferenciaProduto: this.model.ReferenciaProduto(),
            DescricaoProduto: this.model.DescricaoProduto(),
            ClasseProduto: this.model.ClasseProduto(),
            CodigoFornecedor: this.model.CodigoFornecedor(),
            NumeroPagina: pagina,
            TamanhoPagina: this.tamanhoPagina,
            CodigosProdutos: codigosProdutos
        };

        var self = this;

        global.ajax({
            url: "/Cliente/ListarCompras",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({ filtros: filtros }),
            success: function(data) {

                if (!data || data.HasErrors) {
                    return;
                }

                var m = ko.mapping.fromJS(data.Entities);
                self.model.Entities(m());
                self.atualizarPaginador(data);
            }
        });

    },

    pesquisarProduto: function() {


        this.pesquisarProdutosController = this.showView({
            region: {
                name: "pesquisarProdutosUltimasComprasRegion",
                selector: "#pesquisar-produto-ultimas-compras-region"
            },
            controller: {
                type: PesquisarProdutosController,
                args: {
                    model: this.orcamento,
                    orcamento: this.orcamento,
                    adicionarProdutosCallback: $.proxy(this.adicionarProdutos, this),
                    esconderForaEstoque: true
                }
            }

        });

    },

    adicionarProdutos: function(produtos) {

        if (!produtos) {
            return;
        }

        this.pesquisarProdutosController.hide();
        this.show();

        var self = this;

        $.each(produtos,
            function() {
                self.model.Produtos.push(this);
            });


    },

    removerProduto: function(produto) {

        if (!produto) {
            return;
        }

        this.model.Produtos.remove(produto);

    },


    mostrarFiltrosProduto: function () {
        $("#mostrar-filtros-produto").toggleClass("oculto");

        var $filtros = $("#filtros-produto");

        if ($filtros.is(":visible")) {
            $filtros.slideUp(200);
        } else {
            $filtros.slideDown(200);
        }

    },

    mostrarProdutosFiltro: function () {
        $("#mostrar-produtos-filtro").toggleClass("oculto");

        var $filtros = $("#produtos-filtro");

        if ($filtros.is(":visible")) {
            $filtros.slideUp(200);
        } else {
            $filtros.slideDown(200);
        }

    },

    pesquisarFornecedores: function () {

        this.pesquisarFornecedoresController = this.showView({
            region: {
                name: "pesquisarFornecedoresRegion",
                selector: "#pesquisar-fornecedores-ultimas-compras-region"
            },
            controller: {
                type: PesquisarFornecedoresController,
                args: {
                    fornecedorSelecionadoCallback: $.proxy(this.fornecedorSelecionado, this)
                }
            }

        });
    },

    pesquisarClasses: function () {

        this.pesquisarClassesProdutosController = this.showView({
            region: {
                name: "pesquisarClassesProdutosRegion",
                selector: "#pesquisar-classes-produtos-ultimas-compras-region"
            },
            controller: {
                type: PesquisarClassesProdutosController,
                args: {
                    classeSelecionadaCallback: $.proxy(this.classeSelecionada, this)
                }
            }

        });

    },

    classeSelecionada: function (classe) {
        this.pesquisarClassesProdutosController.hide();
        this.show();
        this.model.ClasseProduto(classe.ClasseProduto);
    },

    fornecedorSelecionado: function (fornecedor) {
        this.pesquisarFornecedoresController.hide();
        this.show();
        this.model.CodigoFornecedor(fornecedor.get("CodigoInterno"));
        this.model.NomeFornecedor(fornecedor.get("Nome"));
    },

    removerClasse: function () {
        this.model.ClasseProduto(null);
    },

    removerFornecedor: function () {
        this.model.CodigoFornecedor(null);
        this.model.NomeFornecedor(null);
    },


});